import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import {
  postSchoolManagerPetition,
  getSchoolByUserRequest,
} from "../../../../../Backend/SchoolsRequests";
import { FormInput } from "../../../../../Components";
import { hasValue } from "../../../../../Helpers/validations/common";
import "./PetitionSchoolModal.scss";

export function PetitionSchoolModal({ user, ...props }) {
  const [t] = useTranslation();
  const [allSchools, setAllSchools] = useState([]);
  const [schoolsApplied, setSchoolsApplied] = useState([]);
  const [schoolsSelected, setSchoolsSelected] = useState([]);
  const [allSchoolsFiltered, setAllSchoolsFiltered] = useState([]);

  const [filters, setFilters] = useState({
    schoolNumber: "",
    schoolName: "",
  });

  useEffect(() => {
    getSchoolsByUser();
  }, []);

  useEffect(() => {
    if (allSchools.length > 0) {
      filterSchools();
    }
  }, [filters]);

  const getSchoolsByUser = async () => {
    const resp = await getSchoolByUserRequest({ userId: user.id });

    if (resp.success) {
      setAllSchools(resp.data.filter((sc) => !sc.isActive && !sc.isPending));
      setAllSchoolsFiltered(resp.data.filter((sc) => !sc.isActive && !sc.isPending));
      setSchoolsApplied(resp.data.filter((sc) => sc.isPending));
    }
  };

  const filterSchools = () => {
    const filteredSchools = allSchools.filter((school) => {
      const matchesSchoolNumber = hasValue(filters.schoolNumber)
        ? school.schoolNumber.toString() === filters.schoolNumber
        : true;
      const matchesSchoolName = school.name
        .toLowerCase()
        .includes(filters.schoolName.toLowerCase());

      return matchesSchoolNumber && matchesSchoolName;
    });
    setAllSchoolsFiltered(filteredSchools);
  };

  const handleChecked = (isChecked, schoolId) => {
    if (isChecked) {
      const updatedList = schoolsSelected.filter((sc) => sc !== schoolId);
      setSchoolsSelected(updatedList);
    } else {
      setSchoolsSelected((prevList) => [...prevList, schoolId]);
    }
  };

  const postSchoolPetitions = async () => {
    const resp = await postSchoolManagerPetition(user.id, schoolsSelected);

    if (resp.success) {
      props.onHide();
    }
  };

  const renderSchool = (school, i, withCheck) => {
    const isChecked = schoolsSelected.find((sc) => sc === school.id);

    return (
      <div className="school-wrapper" key={"school-" + school + "-" + i}>
        {withCheck && (
          <div
            className="checkbox"
            onClick={() => handleChecked(isChecked, school.id)}
          >
            {isChecked ? "check_box" : "check_box_outline_blank"}
          </div>
        )}
        <div className="select-school">
          <div className="school-number">{school.schoolNumber}</div>
          <div className="school-name">{school.name}</div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      {...props}
      size="lg"
      centered
      dialogClassName="petition-school-modal"
    >
      <Modal.Header className="petition-school-modal-header" closeButton>
        <div className="title">{t("SetPetitionSchools")}</div>
      </Modal.Header>
      <Modal.Body className="petition-school-modal-content">
        <div className="description">{t("SetPetitionSchoolsDescription")}</div>
        <div className="content-wrapper">
          <div className="school-list-wrapper">
            <div className="subtitle">{`${t("Schools")}`}</div>
            <div className="description-list">{`${t(
              "SchoolManageDescription"
            )}`}</div>
            <div className="school-list">
              {allSchools.length > 0 ? (
                <React.Fragment>
                  <div className="filters-wrapper">
                    <div className="input-wrapper">
                      <span className="label">{t("SchoolNumber")}</span>
                      <FormInput
                        placeholder=""
                        type="text"
                        value={filters.schoolNumber}
                        change={(x) => {
                          if (/^\d*$/.test(x)) {
                            setFilters({ ...filters, schoolNumber: x });
                          }
                        }}
                      />
                    </div>
                    <div className="input-wrapper">
                      <span className="label">{t("SchoolName")}</span>
                      <FormInput
                        placeholder=""
                        type="text"
                        value={filters.schoolName}
                        change={(x) =>
                          setFilters({ ...filters, schoolName: x })
                        }
                      />
                    </div>
                  </div>
                  {allSchoolsFiltered.map((school, i) =>
                    renderSchool(school, i, true)
                  )}
                </React.Fragment>
              ) : (
                <div className="message-wrapper" key={"empty"}>
                  {t("NoSchoolsToBeApplied")}
                </div>
              )}
            </div>
          </div>
          <div className="school-list-wrapper">
            <div className="subtitle">{`${t("SchoolsThatArePending")}`}</div>
            <div className="description-list">{`${t(
              "SchoolPendingDescription"
            )}`}</div>
            <div className="school-list">
              {schoolsApplied.length > 0 ? (
                schoolsApplied.map((school, i) =>
                  renderSchool(school, i, false)
                )
              ) : (
                <div className="message-wrapper" key={"empty"}>
                  {t("NoSchoolsPending")}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="button-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Cancel")}
          </Button>
          <Button
            className="button"
            disabled={schoolsSelected.length === 0}
            onClick={() => postSchoolPetitions()}
          >
            {t("SendPetition")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
